import { EmptyState, PixelPlaceholderLoader } from "@similarweb/ui-components";

import type {
    RankingDistributionCompareModeData,
    RankingDistributionMetric,
} from "app/pages/keyword-research/website-analysis/pages/ranking-distribution/rankingDistribution.types";
import { getConfig } from "app/pages/keyword-research/website-analysis/pages/ranking-distribution/RankingDistributionChart.utils";
import {
    PixelPlaceholderLoaderWrapper,
    RankingDistributionChartWrapper,
} from "app/pages/keyword-research/website-analysis/pages/ranking-distribution/StyledComponents";
import Chart from "pro-features/components/Chart/src/Chart";

type RankingDistributionChartProps = {
    metric: RankingDistributionMetric;
    data: RankingDistributionCompareModeData;
    translatedWords: Record<string, string>;
    tooltipSubtitle: string;
    isLoading: boolean;
    hasData: boolean;
};

export const RankingDistributionChart = ({
    metric,
    data,
    translatedWords,
    tooltipSubtitle,
    isLoading,
    hasData,
}: RankingDistributionChartProps) => {
    if (isLoading) {
        return (
            <RankingDistributionChartWrapper>
                <PixelPlaceholderLoaderWrapper>
                    <PixelPlaceholderLoader
                        width={"100%"}
                        height={"100%"}
                    />
                </PixelPlaceholderLoaderWrapper>
            </RankingDistributionChartWrapper>
        );
    }
    return (
        <RankingDistributionChartWrapper>
            {hasData ? (
                <Chart
                    type={"column"}
                    data={data}
                    config={getConfig({
                        metric,
                        data,
                        translatedWords,
                        tooltipSubtitle,
                    })}
                />
            ) : (
                <EmptyState
                    title={translatedWords.noDataTitle}
                    subtitle={translatedWords.noDataSubtitle}
                />
            )}
        </RankingDistributionChartWrapper>
    );
};
